import { render, staticRenderFns } from "./AddFileAttachmentShared.vue?vue&type=template&id=23e39771"
import script from "./AddFileAttachmentShared.vue?vue&type=script&lang=js"
export * from "./AddFileAttachmentShared.vue?vue&type=script&lang=js"
import style0 from "./AddFileAttachmentShared.vue?vue&type=style&index=0&id=23e39771&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports